import React from "react";
import Icon from "@ant-design/icons";

const ProjectInfoSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill={fill}
		>
			<path
				d="M6 8H8.5M6 10H8.5M6 12H8.5M10.5 12.5H12C12.8284 12.5 13.5 11.8284 13.5 11V4.07214C13.5 3.31549 12.9367 2.67344 12.1826 2.61085C11.9338 2.59019 11.6841 2.57239 11.4337 2.55746M7.56635 2.55746C7.52322 2.69734 7.5 2.84596 7.5 3C7.5 3.27614 7.72386 3.5 8 3.5H11C11.2761 3.5 11.5 3.27614 11.5 3C11.5 2.84596 11.4768 2.69734 11.4337 2.55746M7.56635 2.55746C7.75517 1.94505 8.32561 1.5 9 1.5H10C10.6744 1.5 11.2448 1.94505 11.4337 2.55746M7.56635 2.55746C7.31591 2.57239 7.06625 2.59019 6.81739 2.61085C6.06333 2.67344 5.5 3.31549 5.5 4.07215V5.5M5.5 5.5H3.25C2.83579 5.5 2.5 5.83579 2.5 6.25V13.75C2.5 14.1642 2.83579 14.5 3.25 14.5H9.75C10.1642 14.5 10.5 14.1642 10.5 13.75V6.25C10.5 5.83579 10.1642 5.5 9.75 5.5H5.5ZM4.5 8H4.505V8.005H4.5V8ZM4.5 10H4.505V10.005H4.5V10ZM4.5 12H4.505V12.005H4.5V12Z"
				stroke="#344054"
				// stroke-linecap="round"
				// stroke-linejoin="round"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
const ProjectInfoIcon = (props) => (
	<Icon component={() => <ProjectInfoSvg {...props} />} />
);

export default ProjectInfoIcon;
